// Three-way valve vertex schema
// Complex multi-port device. Single elevation.

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema } from '../base/common';

// --- Port operation modes ---

const ThreeWayValvePortFlowVolumetricSchema = z.object({
  mode: z.literal('flow_volumetric'),
  value: z.number(),
  unit: z.string(),
});

const ThreeWayValvePortFlowMassSchema = z.object({
  mode: z.literal('flow_mass'),
  value: z.number(),
  unit: z.string(),
});

const ThreeWayValvePortPressureDifferentialSchema = z.object({
  mode: z.literal('pressure_differential'),
  value: z.number(),
  unit: z.string(),
});

const ThreeWayValvePortPressureInletSchema = z.object({
  mode: z.literal('pressure_inlet'),
  value: z.number(),
  unit: z.string(),
});

const ThreeWayValvePortPressureOutletSchema = z.object({
  mode: z.literal('pressure_outlet'),
  value: z.number(),
  unit: z.string(),
});

const ThreeWayValvePortValvePositionSchema = z.object({
  mode: z.literal('valve_position'),
  value: z.number(),
  unit: z.string(),
});

const ThreeWayValvePortFixedCvSchema = z.object({
  mode: z.literal('fixed_flow_coefficient'),
  value: z.number(),
  unit: z.string(),
});

export const ThreeWayValvePortOperationSchema = z.discriminatedUnion('mode', [
  ThreeWayValvePortFlowVolumetricSchema,
  ThreeWayValvePortFlowMassSchema,
  ThreeWayValvePortPressureDifferentialSchema,
  ThreeWayValvePortPressureInletSchema,
  ThreeWayValvePortPressureOutletSchema,
  ThreeWayValvePortValvePositionSchema,
  ThreeWayValvePortFixedCvSchema,
]);

export type ThreeWayValvePortOperation = z.infer<typeof ThreeWayValvePortOperationSchema>;

export const ThreeWayValveVertexSchema = BaseVertexSchema.extend({
  type: z.literal('three_way_valve'),
  elevation: ValueWithUnitSchema,
  operation_port_a: ThreeWayValvePortOperationSchema,
  operation_port_b: ThreeWayValvePortOperationSchema,
  port_a_edge_id: z.string().optional(),
  port_b_edge_id: z.string().optional(),
});

export type ThreeWayValveVertex = z.infer<typeof ThreeWayValveVertexSchema>;
